import { render, staticRenderFns } from "./TaskRequestList.vue?vue&type=template&id=5e4e128b"
import script from "./TaskRequestList.vue?vue&type=script&lang=js"
export * from "./TaskRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports